import seon, { SDKInitOptions, SDKOptions } from "@seontechnologies/seon-javascript-sdk";
import logger from "@utils/logger";

const DEFAULT_INIT_CONFIG: SDKInitOptions = {};
const DEFAULT_CONFIG: SDKOptions = {};

/**
 * Get seon session id with default config
 * Returns undefined if the operation takes longer than 2000ms
 *
 */
export const getSeonSession = async (config?: SDKOptions) => {
  try {
    const timeoutPromise = new Promise<never>((_, reject) => {
      setTimeout(() => reject(new Error("Seon session timeout")), 2000);
    });
    timeoutPromise.catch(() => {});

    const seonSessionPromise = seon.getSession({ ...DEFAULT_CONFIG, ...(config ?? {}) });

    return await Promise.race([seonSessionPromise, timeoutPromise]);
  } catch (error) {
    logger._console.log("Error getting seon session id", error);
    return undefined;
  }
};

/**
 * Initialize seon with default config
 */
export const initSeon = (config?: SDKInitOptions) => {
  try {
    seon.init({ ...DEFAULT_INIT_CONFIG, ...(config ?? {}) });
  } catch (error) {
    logger._console.log("Error initializing seon", error);
  }
};
